"use client";
import { useState } from "react";
import { GuideCard } from "../guide-card";
import { Button } from "@/components/ui/button";
import { GuidesEmpty } from "./empty";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { useGuidesBySearch } from "@/hooks/useGuidesBySearch";
import { useMediaQuery } from "@/hooks/useMediaQuery";

export type Feature = "buy-for-me" | "wallet" | "store" | "ship";

export function GuidesSearchContent({ searchQuery }: { searchQuery: string }) {
  const [page, setPage] = useState(1);

  const isMobile = useMediaQuery("(max-width: 768px)");
  const limit = isMobile ? 3 : 6;
  const { data } = useGuidesBySearch({
    queryParams: {
      search: searchQuery,
      page,
      limit,
    },
  });

  const { items, total } = data;

  return (
    <section className="py-16 sm:py-20 lg:py-24 font-outfit bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="flex flex-col items-center mb-12 sm:mb-16">
          <span className="inline-block text-sm sm:text-base font-medium rounded-full px-6 py-2.5 bg-primary-50 text-[#0D0D0D] mb-4">
            Search Results
          </span>
        </div>

        {items.length > 0 ? (
          <div className="space-y-12">
            <div className="grid grid-cols-[repeat(auto-fill,minmax(min(100%,300px),1fr))] gap-6 lg:gap-8">
              {items.map((guide) => (
                <GuideCard key={guide._id} guide={guide} />
              ))}
            </div>

            <div className="flex items-center justify-end gap-3 pt-4">
              <span className="px-4 py-2 text-sm font-medium text-gray-700 rounded-lg">
                page {page} of {Math.ceil(total / limit)}
              </span>

              <Button
                onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                variant="outline"
                size="icon"
                radius="full"
                disabled={page == 1}
              >
                <ArrowLeft />
              </Button>

              <Button
                onClick={() => setPage((prev) => prev + 1)}
                variant="outline"
                size="icon"
                radius="full"
                disabled={page * limit >= total}
              >
                <ArrowRight />
              </Button>
            </div>
          </div>
        ) : (
          <GuidesEmpty sectionTitle="Search Results" />
        )}
      </div>
    </section>
  );
}
